import { ThemeBus } from './events-bus.js';
import { EVENTS } from './event-constants.js';

/**
 * Blog Load More
 * Fetches the next page of blog articles via the Section Rendering API
 * and appends them to the existing grid without a full page reload.
 * Uses event delegation so buttons inserted after a tag filter still work.
 */
class BlogLoadMore {
  constructor() {
    document.addEventListener('click', e => {
      const button = e.target.closest('[data-blog-load-more]');
      if (!button) return;
      this.loadMore(button);
    });
  }

  async loadMore(button) {
    if (button.dataset.loading) return;

    const nextUrl = button.dataset.nextUrl;
    const gridId = button.dataset.gridId;
    const sectionId = button.dataset.sectionId;

    if (!nextUrl || !gridId || !sectionId) return;

    const originalText = button.textContent.trim();
    button.dataset.loading = 'true';
    button.disabled = true;
    button.textContent = '...';

    try {
      const separator = nextUrl.includes('?') ? '&' : '?';
      const url = `${nextUrl}${separator}sections=${sectionId}`;

      const response = await fetch(url);
      if (!response.ok) throw new Error(`HTTP error: ${response.status}`);

      const json = await response.json();
      const sectionHtml = json[sectionId];
      if (!sectionHtml) throw new Error('Section HTML not found in response');

      const doc = new DOMParser().parseFromString(sectionHtml, 'text/html');

      const newGrid = doc.querySelector(`#${gridId} .slider-content`);
      if (!newGrid) throw new Error('Grid not found in response');

      const liveGrid = document.querySelector(`#${gridId} .slider-content`);
      Array.from(newGrid.children).forEach(card => liveGrid.appendChild(card));

      ThemeBus.dispatchEvent(new Event(EVENTS.gridUpdated));

      const newButton = doc.querySelector('[data-blog-load-more]');
      if (newButton?.dataset.nextUrl) {
        button.dataset.nextUrl = newButton.dataset.nextUrl;
        button.textContent = originalText;
        button.disabled = false;
      } else {
        button.closest('div')?.remove();
      }
    } catch (_error) {
      button.textContent = originalText;
      button.disabled = false;
    }

    delete button.dataset.loading;
  }
}

new BlogLoadMore();
